import { createI18n } from 'vue-i18n';

// Import avec typage
import en from '@/i18n/locales/en.json';
import fr from '@/i18n/locales/fr.json';

// Source unique de vérité pour les langues
export const languageOptions = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' }
] as const;

// Dériver automatiquement le type des locales supportées
export type SupportedLocale = typeof languageOptions[number]['value'];

// Dériver le tableau des locales
export const SUPPORTED_LOCALES: readonly SupportedLocale[] = languageOptions.map((lang) => lang.value);

export const i18n = createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {
    en,
    fr
  },
  missingWarn: true,
  fallbackWarn: true,
  allowComposition: true,
});

// Exporter l'instance globale
export const global = i18n.global;
export default i18n;
